import React, {useEffect, useState} from 'react';
import {
    getAlbumByArtistId,
    getArtistById,
    getMostPopularArtistPlaylistBySpotify, getPlaylistsBySpotifyCountByArtistId,
    getRelatedArtists, getVisibilityScore
} from "../../api/spotify-helper";
import {initPopularityData} from "../../functions";
import { Placeholder } from 'semantic-ui-react'
import Schema from "./Schema";
import {getArtistVisibilityCount, getMostVisibleRow, getScore} from "../../api/database-helper";


export default function Dashboard() {
    const [artist, setArtist] = useState(null)
    const [related, setRelated] = useState([])
    const [playlist, setPlaylist] = useState(null);
    const [albums, setAlbums] = useState(null);
    const [visibilityScore, setVisibilityScore] = useState(null);
    const [visibilityScoreNew, setVisibilityScoreNew] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.get('artist')) {
            const artistId = urlParams.get('artist');

            getScore(artistId).then(s => {
                setVisibilityScoreNew(`${Math.floor(s)}%`)
                setIsLoading(false)
            });

            getArtistById(artistId).then(data => {
                setArtist(data)
                getMostPopularArtistPlaylistBySpotify(data).then(data => {
                    setPlaylist(data);
                })
                getVisibilityScore(data).then(data => setVisibilityScore(data));
            });
            getRelatedArtists(artistId).then(data => setRelated(data.artists))
            getAlbumByArtistId(artistId).then(data => setAlbums(data))
        }

    }, [])

    useEffect(() => {
        if (
            document.getElementById('canvas') !== null &&
            artist !== null
        ) {
            initPopularityData(artist.popularity, document.getElementById('canvas'));
        }
    }, [artist])

    return (
        <div className="dashboard">
            {artist && (
                <div className="dashboard__panel">
                    <div className="dashboard__panel__intro d-flex align-items-center justify-content-between flex-wrap mb-3">
                        <div className="d-flex align-items-center">
                            {artist.images && (
                                <img src={artist.images[1].url} alt={`Image de ${artist.name}`} />
                            )}
                            <h4 className="h1 ms-3">{artist.name}</h4>
                        </div>
                        <div className="pt-3 ms-3 mb-3">
                            <div className="popularity-wrap">
                                <canvas id="canvas"></canvas>
                                <span id="procent"></span>
                                <div className="label">Popularité</div>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard__panel__content">
                        <div style={{minHeight: '45px'}}>
                            {visibilityScoreNew && (
                                <div className="icon-wrap">
                                    <i className="fas fa-eye"></i>
                                    <div className="table-title table-title--regular">
                                        <strong>Est visible à {visibilityScoreNew}</strong>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/*{isLoading && (*/}
                        {/*    <Placeholder>*/}
                        {/*        <Placeholder.Line />*/}
                        {/*    </Placeholder>*/}
                        {/*)}*/}

                        {/*{(visibilityScore && !isLoading) && (*/}
                        {/*    <div className="icon-wrap">*/}
                        {/*        <i className="fas fa-star"></i>*/}
                        {/*        <div className="table-title table-title--regular">*/}
                        {/*            <strong>Apparaît dans {visibilityScore} playlists éditoriales sur Spotify</strong>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*)}*/}

                        {artist.followers && (
                            <div className="icon-wrap">
                                <i className="fas fa-users"></i>
                                <div className="table-title table-title--regular">
                                    <strong>Followers :</strong> {artist.followers.total.toLocaleString()}
                                </div>
                            </div>
                        )}
                        {artist.genres.length > 0 && (
                            <div className="icon-wrap">
                                <i className="fas fa-music"></i>
                                <div className="table-title table-title--regular">
                                    <strong>Genre :</strong> {artist.genres.join(' / ')}
                                </div>
                            </div>
                        )}
                        {albums && (
                            <div className="icon-wrap">
                                <i className="fas fa-compact-disc"></i>
                                <div className="table-title table-title--regular">
                                    <strong>Albums & Titres :</strong> {albums.total}
                                </div>
                            </div>
                        )}
                        <div className="icon-wrap">
                            <i className="fab fa-spotify"></i>
                            <div className="table-title">
                                <a href={`https://open.spotify.com/artist/${artist.id}`} target="_blank">Voir sur Spotify</a>
                            </div>
                        </div>
                    </div>
                </div>
           )}

            {(related && related.length > 0) && (
                <div className="dashboard__panel mb-3">
                    <h3 className="pt-0">Artistes recommandés</h3>
                    <ul className="related-artists d-xl-none">
                        {related.slice(0, 10).map((artist, index) => (
                            <li key={index}>
                                <a href={`${window.location.origin}/?page=dashboard&artist=${artist.id}`} className="d-flex justify-content-between">
                                    <span>{artist.name}</span>
                                    <u>Voir</u>
                                </a>
                            </li>
                        ))}
                    </ul>
                    {artist && (
                        <Schema artistsRelated={related} artist={artist}  />
                    )}
                </div>
            )}

            {playlist && (
                <iframe style={{borderRadius: '12px'}}
                        src={`https://open.spotify.com/embed/playlist/${playlist.id}?utm_source=generator`}
                        width="100%" height="352" frameBorder="0" allowFullScreen=""
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                        loading="lazy">
                </iframe>
            )}

            {/*{artist == null && (*/}
            {/*    <div className="dashboard__panel dashboard__panel--fake">*/}
            {/*        <Placeholder>*/}
            {/*            <Placeholder.Header image>*/}
            {/*                <Placeholder.Line length='medium' />*/}
            {/*                <Placeholder.Line length='full' />*/}
            {/*            </Placeholder.Header>*/}
            {/*            <Placeholder.Paragraph>*/}
            {/*                <Placeholder.Line length='full' />*/}
            {/*                <Placeholder.Line length='medium' />*/}
            {/*            </Placeholder.Paragraph>*/}
            {/*        </Placeholder>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    )
}